import { FeatureToggleService } from "@gtmhub/featureToggle";
import { FeatureFlag } from "@gtmhub/featureToggle/models";
import { IPromise } from "angular";
import languages from "wwwroot/json/languages.json";
import { ILanguageMap } from "../models";
import { filterLanguages } from "../utils";

export class LanguagesConfigService {
  // TODO: Delete this service and use only languages.json when "Italian" is released
  static $inject = ["FeatureToggleService"];

  constructor(private featureToggleService: FeatureToggleService) {}

  getLanguageMap(): IPromise<ILanguageMap> {
    return this.featureToggleService
      .isFeatureAvailable(FeatureFlag.Italian)
      .then((enabled) => (enabled ? languages.languageMap : filterLanguages("italian", languages.languageMap)));
  }
}
